module.exports = __webpack_public_path__ + "static/img/logo56.c613a4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo56.png
// module id = A9AM
// module chunks = 1